
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class PageHeadListToggle extends Vue {
  @Prop(Boolean) readonly list!: boolean;

  toggle() {
    this.$emit("update:list", !this.list);
  }
}
